import d3 from 'd3';
import {
  Measure
} from '../common/measure';

require('./pie.component.scss');

/*@ngInject*/
const other = gettext('Всё остальное');
const maxLegends = 20;
const CaptionsFontSize = 14;
const CaptionsFontFamily = 'sans-serif';

const browserText = (function() {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  /**
   * Measures the rendered width of arbitrary text given the font size and font face
   * @param {string} text The text to measure
   * @param {number} fontSize The font size in pixels
   * @param {string} fontFace The font face ("Arial", "Helvetica", etc.)
   * @returns {number} The width of the text
   **/
  function getWidth(text) {
    context.font = `${CaptionsFontSize}px ${CaptionsFontFamily}`;
    return context.measureText(text).width;
  }
  return {
    getWidth: getWidth
  };
}());

class PieController {
  constructor($scope, $rootScope, $element, RouterService, rx, $timeout) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.router = RouterService;
    this.legendWidth = 0;
    this.$timeout = $timeout;
    this.showCaptions = true;

    const subscriptions = [
      rx.Observable.merge(
        rx.Observable.merge(
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed')
        ).debounce(100),
        rx.Observable.merge(
          $scope.$toObservable('$ctrl.filter.orders'),
          $scope.$toObservable('$ctrl.filter.orderDirs'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(100),

        $scope.$eventToObservable('resizeBeforePrint'),
        $scope.$eventToObservable('afterPrint'),
        $scope.$eventToObservable('init')
      ).subscribe(e => {
        this.render();
      })
    ];

    $scope.$on('$destroy', () => {
      subscriptions.forEach(subscription => {
        subscription.dispose();
      });
    });
  }

  $postLink() {}

  hideCaptions() {
    this.showCaptions = !this.showCaptions;
    this.render();
  }

  get aggregate() {
    return this._aggregate;
  }

  set aggregate(value) {
    this._aggregate = value;
    if (!this.legendWidth) {
      this.$timeout(this.render(), 0);
    } else this.render();
  }

  render() {
    const _this = this;
    const isDashboardPdf = this.router.pdf && this.router.CurrentFilterService.filter.isCardOrDashboard;
    const statChart = this.$element[0].querySelector('.stat-chart');
    const statSequence = this.$element[0].querySelector('.stat-sequence');
    const statLegend = this.$element[0].querySelector('.stat-legend');

    const aggregate = this.aggregate;
    const sortKeys = {
      orders: this.filter.orders,
      orderDirs: this.filter.orderDirs,
      drill1: this.model.getDrillAttr(this.filter.drilldown[0])
    };

    if (!aggregate || !aggregate.cells) {
      return;
    }

    this.$element.find('svg').remove();

    const width = this.$element.width();

    let dims = {};

    const getLegendWidth = g => {
      // const legend = _this.$element.find('.stat-legend');
      // const k = legend.width() / legend[0].getBoundingClientRect().width;
      const legendW = g[0].reduce((mw, l) => {
        const w = l.getBoundingClientRect().width;
        if (mw < w) mw = w;
        return mw;
      }, 0);
      return Math.round(legendW);
    };


    let totalSize = aggregate.cells.reduce(
      (acc, c) => acc + c[aggregate.filter.measure], 0);

    // Mapping of step names to colors.
    const colors = {};
    const getColor = label => {
      if (label in colors) return colors[label];
      return colors[other];
    };

    const json = buildHierarchy(aggregate.cells);
    drawLegend();
    // Dimensions of sunburst.

    let height = Math.min(
      this.$element.width() - _this.maxLegendWidth / (isDashboardPdf ? 2 : 1),
      this.$element.height() - (isDashboardPdf ? 15 : 50)
    );

    if (isDashboardPdf) height *= 3; //this.$element.closest('sc-dashboard').width() / this.$element.width();
    if (height > 650) height = 650;
    if (height < 50) height = 50;

    _this.height = Math.round(height);
    const radius = height / 2;
    if (height < 50 || width < 50) return;
    // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
    const b = {
      w: 175,
      h: 30,
      s: 3,
      t: 10
    };

    // Total size of all segments; we set this later, after loading the data.

    const vis = d3
      .select(statChart)
      .append('svg:svg')
      .attr('width', height)
      .attr('height', height)
      .append('svg:g')
      .attr('id', 'stat-container')
      .attr('transform', 'translate(' + (height / 2) +
        ',' + (height / 2) + ')');


    const partition = d3.layout
      .partition()
      .size([2 * Math.PI, radius * radius])
      .value(d => d.size);

    const arc = d3.svg
      .arc()
      .startAngle(d => d.x)
      .endAngle(d => d.x + d.dx)
      .innerRadius(d => d.innerRadius)
      .outerRadius(d => d.outerRadius);


    // Main function to draw and set up the visualization, once we have the data.
    function createVisualization(json) {
      // Basic setup of page elements.
      initializeBreadcrumbTrail();
      // drawLegend();

      // Bounding circle underneath the sunburst, to make it easier to detect
      // when the mouse leaves the parent g.
      vis
        .append('svg:circle')
        .attr('r', radius)
        .style('opacity', 0);

      // For efficiency, filter nodes to keep only those large enough to see.
      const captionDisplay = d => {
        const innerRad = d.outerRadius - d.captionWidth < 50 ? 50 : d.outerRadius - d.captionWidth;
        if (!d.depth || ((d.depth === 1) && (d.dx * innerRad) < CaptionsFontSize)) return 'none';
        return '';
      };


      const nodes = partition.nodes(json).filter(d => {
        return d.dx > 0.005; // 0.005 radians = 0.29 degrees
      }).map(d => {
        d.captionName = d.name;
        d.captionWidth = browserText.getWidth(d.name);
        d.outerRadius = Math.sqrt(d.y);
        d.innerRadius = d.y - d.dy > 0 ? Math.sqrt(d.y - d.dy) : 0;
        const length = d.depth > 1 ? ((d.outerRadius + d.innerRadius) / 2) * d.dx - 10 : d.outerRadius * 0.9 - 16;
        if (length < d.captionWidth) {
          d.captionName = d.name.substr(0, Math.floor(d.name.length * length / d.captionWidth));
          if (d.captionName.length && d.captionName.length < d.name.length) d.captionName += '...';
        }
        return d;
      });

      const path = vis
        .data([json])
        .selectAll('path')
        .data(nodes)
        .enter()
        .append('svg:path')
        .attr('display', d => (d.depth ? null : 'none'))
        .attr('d', arc)
        .attr('fill-rule', 'evenodd')
        .style('fill', d => getColor(d.name))
        .style('opacity', 1)
        .style('cursor', 'pointer')
        .on('mouseover', mouseover)
        .on('click', mouseclick)
        .append('text');

      if (_this.showCaptions) {
        const captionsArc = d3.svg
          .arc()
          .startAngle(d => d.depth === 1 ? d.x + d.dx / 2 : d.x)
          .endAngle(d => d.depth === 1 ? d.x + d.dx / 2 : d.x + d.dx)
          .innerRadius(d => d.depth === 1 ? 0 : (d.outerRadius + d.innerRadius) / 2)
          .outerRadius(d => d.depth === 1 ? d.outerRadius * 0.9 : (d.outerRadius + d.innerRadius) / 2);

        vis
          .data([json])
          .selectAll('.captionsPath')
          .data(nodes)
          .enter()
          .append('path')
          .attr('class', 'captionsPath')
          // .style('display', 'none')
          .attr('transform', d => `translate(${d.depth === 1?
          -CaptionsFontSize / 3 * Math.cos(d.x + d.dx / 2) : 0}, ${d.depth === 1?
            -CaptionsFontSize / 3 * Math.sin(d.x + d.dx / 2): 0})`)
          .attr('id', (d, i) => 'id_pie_segment_' + _this.filter.id + '_' + i)
          .attr('d', captionsArc);


        vis
          .data([json])
          .selectAll('.captionsText')
          .data(nodes)
          .enter()
          .append('text')
          .append('textPath')
          .attr('xlink:href', (d, i) => '#id_pie_segment_' + _this.filter.id + '_' + i)
          .attr('startOffset', d => {
            if (d.depth === 1) return '0%';
            const length = (d.outerRadius - 20) * d.dx - 10;
            const space = length - d.captionWidth;
            if (space <= 0) return '5%';
            return `${space / 3 / length * 100}%`;
          })
          .attr('class', 'captionsText')
          .attr('display', d => captionDisplay(d))
          .on('mouseover', mouseover)
          .style('cursor', 'pointer')
          .style('font-size', CaptionsFontSize)
          .style('font-family', CaptionsFontFamily)
          .on('click', mouseclick)
          .text(d => d.captionName);
      }

      // Add the mouseleave handler to the bounding circle.
      vis.on('mouseleave', mouseleave);

      // Get total size of the tree = value of root node from partition.
      totalSize = path.node() ? path.node().__data__.value : 0;
    }

    function mouseclick(d) {
      _this.router.drilldownFilter(d.filter);
      _this.$rootScope.$digest();
    }

    // Fade all but the current sequence, and show it in the breadcrumb trail.
    function mouseover(d) {
      const sequenceArray = getAncestors(d);
      const cell = {};
      cell[_this.aggregate.filter.measure] = d.value;
      const val = Measure.getMeasure(cell, _this.aggregate.filter.measure);
      updateBreadcrumbs(sequenceArray, val, d.value);

      // Fade all the segments.
      d3.selectAll('path').style('opacitthis.$element.height()', 0.3);

      // Then highlight only those that are an ancestor of the current segment.
      vis
        .selectAll('path')
        .filter(node => sequenceArray.indexOf(node) >= 0)
        .style('opacity', 1);
    }

    // Restore everything to full opacity when moving off the visualization.
    function mouseleave() {
      // Hide the breadcrumb trail
      d3.select(statSequence)
        .select('#stat-trail')
        .style('visibility', 'hidden');

      // Deactivate all segments during transition.
      //               d3.selectAll("path").on("mouseover", null);

      // Transition each segment to full opacity and then reactivate it.
      d3.select(statChart)
        .selectAll('path')
        .transition()
        .duration(1000)
        .style('opacity', 1)
        .each('end', function() {
          d3.select(this).on('mouseover', mouseover);
        });
    }

    // Given a node in a partition layout, return an array of all of its ancestor
    // nodes, highest first, but excluding the root.
    function getAncestors(node) {
      const path = [];
      let current = node;
      while (current.parent) {
        path.unshift(current);
        current = current.parent;
      }
      return path;
    }

    function initializeBreadcrumbTrail() {
      // Add the svg area.
      const trail = d3
        .select(statSequence)
        .append('svg:svg')
        .attr('width', width)
        .attr('height', 50)
        .attr('id', 'stat-trail');
      // Add the label at the end, for the percentage.
      trail
        .append('svg:text')
        .attr('id', 'stat-endlabel')
        .style('fill', '#000');
    }

    // Generate a string that describes the points of a breadcrumb polygon.
    function breadcrumbPoints(d, i) {
      const points = [];
      points.push('0,0');
      points.push(b.w + ',0');
      points.push(b.w + b.t + ',' + b.h / 2);
      points.push(b.w + ',' + b.h);
      points.push('0,' + b.h);
      if (i > 0) {
        // Leftmost breadcrumb; don't include 6th vertex.
        points.push(b.t + ',' + b.h / 2);
      }
      return points.join(' ');
    }

    // Update the breadcrumb trail to show the current sequence and percentage.
    function updateBreadcrumbs(nodeArray, total, size) {
      // Data join; key function combines name and depth (= position in sequence).
      const g = d3
        .select(statSequence)
        .select('#stat-trail')
        .selectAll('g')
        .data(nodeArray, d => d.name + d.depth);

      // Add breadcrumb and label for entering nodes.
      const entering = g.enter().append('svg:g');

      entering
        .append('svg:polygon')
        .attr('points', breadcrumbPoints)
        .style('fill', d => getColor(d.name));

      const labelText = d => {
        const max = 22;
        if (d.name.length > max) {
          return `${d.name.substr(0, max -3)}...`;
        }
        return d.name;
      };

      entering
        .append('svg:text')
        .attr('x', (b.w + b.t) / 2)
        .attr('y', b.h / 2)
        .attr('width', b.w)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .text(d => labelText(d));

      // Set position for entering and updating nodes.
      g.attr('transform', (d, i) => 'translate(' + i * (b.w + b.s) + ', 0)');

      // Remove exiting nodes.
      g.exit().remove();

      // Now move and update the percentage at the end.
      d3.select(statSequence)
        .select('#stat-trail')
        .select('#stat-endlabel')
        .attr('x', (nodeArray.length + 0.5) * (b.w + b.s))
        .attr('y', b.h / 2)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .text(() => {
          if (size && totalSize) return `${total} (${Math.round(size * 1000 / totalSize) / 10}%)`;
          return total;
        });

      // Make the breadcrumb trail visible, if it's hidden.
      d3.select(statSequence)
        .select('#stat-trail')
        .style('visibility', '');
    }

    function drawLegend() {
      // Dimensions of legend item: width, height, spacing, radius of rounded rect.
      const cR = width / 50;
      const r = cR > 15 ? 15 : cR < 6 ? 6 : cR;
      const li = {
        // w: Math.min(width - height, width / 3),
        w: isDashboardPdf ? width * 5 : width,
        h: r * 2,
        s: 3,
        r: r
      };

      let sortFunc = (a, b) => b.value.data - a.value.data;
      if (sortKeys.orderDirs && sortKeys.orders) {
        if (sortKeys.orders[0] === 'measure' && sortKeys.orderDirs[0] === 'asc') {
          sortFunc = (a, b) => a.value.data - b.value.data;
        } else if (sortKeys.orders[0] === sortKeys.drill1 &&
          sortKeys.orderDirs[0] === 'asc') {
          sortFunc = (a, b) => a.key > b.key ? 1 : (a.key == b.key ? 0 : -1);
        } else if (sortKeys.orders[0] === sortKeys.drill1 &&
          sortKeys.orderDirs[0] === 'desc') {
          sortFunc = (a, b) => a.key > b.key ? -1 : (a.key == b.key ? 0 : 1);
        }
      }

      const dimIndex = 0; //(d3.keys(dims[0]).length == 1) ? 1 : 0
      const entries = d3
        .entries(dims[dimIndex])
        .map(entry => {
          entry.val = getColor(entry.key);
          return entry;
        })
        .sort(sortFunc);

      const mlen = entries.length * (li.h + li.s);
      // if (mlen > heightLegend) mlen = heightLegend;

      const legend = d3
        .select(statLegend)
        .append('svg:svg')
        .attr('width', li.w)
        .attr('height', mlen);

      const g = legend
        .selectAll('g')
        .data(entries)
        .enter()
        .append('svg:g')
        .attr('transform', (d, i) => 'translate(0,' + i * (li.h + li.s) + ')')
        .style('pointer-events', 'all')
        .style('cursor', 'pointer')
        .on('click', d => {
          // console.log('pie legend click');
          if (d.key == other) return;
          _this.router.drilldownFilter(d.value);
          _this.$rootScope.$digest();
        });

      g.append('svg:rect')
        .attr('x', '10px')
        .attr('rx', li.r)
        .attr('ry', li.r)
        .attr('width', li.h) //"20px"//li.w)
        .attr('height', li.h)
        .style('stroke', 'white')
        .style('stroke-width', '1')
        .style('fill', d => d.val)
        .style('opacity', 1);

      g.append('svg:text')
        .attr('x', li.h + 15)
        .attr('y', li.h / 2)
        .attr('dy', '0.35em')
        .attr('width', li.w - li.h)
        .attr('text-anchor', 'left')
        .text(d => Measure.getMeasure(d.value.data, _this.aggregate.filter.measure));

      g.append('svg:text')
        .attr('x', li.h + 10 + getLegendWidth(g))
        .attr('y', li.h / 2)
        .attr('dy', '0.35em')
        .attr('width', li.w - li.h)
        .attr('text-anchor', 'left')
        .text(d => d.value.text);

      _this.maxLegendWidth = Math.round(getLegendWidth(g));

      _this.legendWidth = width / 3;

      const minLegendWidth = _this.legendWidth;
      const fontMin = 10;
      const fontMax = 14;
      let font = 14;
      const k = (minLegendWidth - _this.maxLegendWidth / 2) / minLegendWidth;
      if (_this.maxLegendWidth > minLegendWidth) {
        if (k > 0) font = fontMin + (fontMax - fontMin) * k;
        else font = fontMin;
      }
      statLegend.style.fontSize = font + 'px';
    }

    // Take a 2-column CSV and transform it into a hierarchical structure suitable
    // for a partition layout. The first column is a sequence of step names, from
    // root to leaf, separated by hyphens. The second column is a count of how
    // often that sequence occurred.
    function buildHierarchy(csv) {
      if (!aggregate || !aggregate.filter || !aggregate.filter.drilldown) {
        return null;
      }
      const root = {
        name: 'root',
        children: []
      };

      dims = [];
      for (let i = 0; i < csv.length; i++) {
        const size = csv[i][_this.aggregate.filter.measure];
        const parts = [];

        const drills = aggregate.filter.drilldown;
        for (let j = 0; j < drills.length; j++) {
          dims.push({});
          const filter = _this.model.getCellFilter(drills[j], csv[i]);
          filter.data = size;
          if (!filter.label) {
            filter.label = gettext('Значение не указано');
          }
          // filter.label = `${filter.label} (${csv[i].percentage})`;
          if (dims[j][filter.label]) dims[j][filter.label].data += size;
          else dims[j][filter.label] = filter;
          if (totalSize) dims[j][filter.label].text = `${filter.label} (${
            Math.round(dims[j][filter.label].data * 1000 / totalSize)/10}%)`;
          else dims[j][filter.label].text = filter.label;
          parts.push(filter);
        }
        let currentNode = root;
        for (let j = 0; j < parts.length; j++) {
          const children = currentNode['children'];
          const filter = parts[j];
          const nodeName = filter.label;
          let childNode;
          if (j + 1 < parts.length) {
            // Not yet at the end of the sequence; move down the tree.
            let foundChild = false;
            for (let k = 0; k < children.length; k++) {
              if (children[k]['name'] === nodeName) {
                childNode = children[k];
                foundChild = true;
                break;
              }
            }
            // If we don't already have a child node for this branch, create it.
            if (!foundChild) {
              childNode = {
                name: nodeName,
                filter: filter,
                children: [],
              };
              children.push(childNode);
            }
            currentNode = childNode;
          } else {
            // Reached the end of the sequence; create a leaf node.
            childNode = {
              name: nodeName,
              filter: filter,
              size: size
            };
            children.push(childNode);
          }
        }
      }

      let dim0 = dims[0] ? dims[0] : {};
      dim0 = Object.keys(dim0).sort((a, b) => dim0[b].data - dim0[a].data)
        .reduce((acc, k, i) => {
          if (i < maxLegends - 1) {
            acc[k] = dim0[k];
            if (totalSize)
              acc[k].text = `${k} (${Math.round(acc[k].data * 1000 / totalSize)/10}%)`;
            else acc[k].text = k;

          } else {
            if (!acc[other]) {
              acc[other] = dim0[k];
              acc[other].label = other;
            } else acc[other].data += dim0[k].data;
          }
          return acc;
        }, {});
      if (dim0[other]) {
        if (totalSize) dim0[other].text = `${other} (${
          Math.round(dim0[other].data * 1000 / totalSize)/10}%)`;
        else dim0[other].text = other;
      }

      dims[0] = dim0;
      const color = [d3.scale.category10(), () => '#0088cc'];
      for (let di = 0; di < dims.length; di++) {
        const dim = dims[di];
        let index = 0;
        const single = Object.keys(dims[0]).length === 1;
        for (const d in dim) {
          if ((single && di === 0) || (!single && di > 0))
            colors[d] = color[1](index++ % 10);
          else colors[d] = color[0](index++ % 10);
        }
      }
      return root;
    }

    if (json) createVisualization(json);
  }
}

export const PieComponent = {
  template: require('./pie.component.html'),
  bindings: {
    model: '<',
    filter: '<',
    aggregate: '<'
  },
  controller: PieController
};



// WEBPACK FOOTER //
// ./src/stat/pie.component.js